module.exports = __webpack_public_path__ + "img/HP DesignJet T950 STD-Front Human v1a.1bcf2289.png";